"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRange = void 0;
var React = __importStar(require("react"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var Input_1 = __importDefault(require("../../Input/Input"));
var Calendar_1 = __importDefault(require("../Calendar/Calendar"));
var react_1 = require("react");
var localization_1 = require("@scuf/localization");
var ig_utils_1 = require("../ig_utils");
var DateRange = /** @class */ (function (_super) {
    __extends(DateRange, _super);
    function DateRange() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false,
            openUp: false,
            formattedDate: '',
            month: moment_timezone_1.default(),
            to: moment_timezone_1.default(),
            from: moment_timezone_1.default(),
            dateFormat: '',
            datePlaceholder: '',
        };
        _this.shimLocals = ig_utils_1.shimLocals;
        _this.genFormat = ig_utils_1.genFormat(_this.props.lng, _this.props.displayFormat);
        _this.getMonth = ig_utils_1.getMonth;
        _this.genClasses = ig_utils_1.genClasses;
        _this.handleSelection = ig_utils_1.handleSelection;
        _this.moment = ig_utils_1.configMoment(_this.props.lng, _this.props.timezone, _this.genFormat().dateFormat);
        _this.captureClick = function (e) {
            if (_this.props.disabled)
                return;
            var dom = e.target;
            var closeOnDocumentClick = _this.props.closeOnDocumentClick;
            if (!_this.menuRef.contains(dom) && closeOnDocumentClick) {
                _this.setState({ open: false });
            }
        };
        _this.handleFocus = function () {
            if (_this.props.disabled)
                return;
            _this.setState({ open: true, openUp: false }, function () {
                var rect = _this.overRef.getBoundingClientRect();
                var direction = rect.bottom >= (window.innerHeight || document.documentElement.clientHeight);
                _this.setState({ openUp: direction });
            });
        };
        _this.genPlaceholder = function (dateFormat) {
            var placeholder = _this.props.placeholder;
            var text = placeholder;
            if (!placeholder) {
                text = dateFormat + " - " + dateFormat;
            }
            return text;
        };
        _this.handleUpdate = function (_a) {
            var action = _a.action, payload = _a.payload;
            var _b = _this.state, to = _b.to, from = _b.from;
            var _c = _this.props, onRangeSelect = _c.onRangeSelect, closeOnSelection = _c.closeOnSelection, onTextChange = _c.onTextChange;
            var date = payload.date;
            var dateFormat = _this.state.dateFormat;
            var close = { open: false };
            var complete = false;
            switch (action) {
                case 'ok':
                    _this.setState({ open: false });
                    break;
                case 'cancel':
                    _this.setState({ open: false, to: undefined, from: undefined, formattedDate: '' }, function () {
                        _this.handleSelection({ to: undefined, from: undefined, onRangeSelect: onRangeSelect });
                    });
                    break;
                case 'reset':
                    _this.setState({ to: undefined, from: undefined, formattedDate: '' }, function () {
                        _this.handleSelection({ to: undefined, from: undefined, onRangeSelect: onRangeSelect });
                    });
                    break;
                case 'next':
                    _this.setState({ month: date });
                    break;
                case 'previous':
                    _this.setState({ month: date });
                    break;
                case 'goToToday':
                    _this.setState({ month: date });
                    break;
                case 'selectDay':
                    var range = {
                        to: to ? to.clone() : undefined,
                        from: from ? from.clone() : undefined,
                    };
                    if (!from) {
                        range.from = date;
                    }
                    else if (!to) {
                        if (date.isBefore(range.from)) {
                            range.to = range.from;
                            range.from = date;
                        }
                        else {
                            range.to = date;
                        }
                        complete = true;
                    }
                    else if (to && from) {
                        range.from = date;
                        range.to = undefined;
                    }
                    var formattedDate = "" + (range.from ? range.from.format(dateFormat) : '') + (range.to ? " - " + range.to.format(dateFormat) : '');
                    _this.handleSelection({ to: range.to, from: range.from, onRangeSelect: onRangeSelect });
                    _this.setState(__assign(__assign(__assign({ formattedDate: formattedDate }, range), (complete && closeOnSelection && close)), { rangeValue: {
                            to: range.to && range.to.toDate(),
                            from: range.from && range.from.toDate(),
                        } }));
                    break;
                case 'setDay':
                    var text_1 = payload.text, error_1 = payload.error;
                    if (error_1) {
                        _this.setState({ formattedDate: text_1, open: false }, function () { return _this.handleSelection({ onTextChange: onTextChange, text: text_1, error: error_1 }); });
                    }
                    else {
                        _this.setState({
                            to: payload.to,
                            from: payload.from,
                            formattedDate: text_1,
                            open: false,
                        }, function () {
                            return _this.handleSelection({
                                onRangeSelect: onRangeSelect,
                                onTextChange: onTextChange,
                                text: text_1,
                                error: error_1,
                                to: payload.to,
                                from: payload.from,
                            });
                        });
                    }
                    break;
                default:
                    break;
            }
        };
        _this.handleInputChange = function (value) {
            var _a = _this.props, t = _a.t, disableFuture = _a.disableFuture, disablePast = _a.disablePast, disableWeekends = _a.disableWeekends, i18nErrors = _a.i18nErrors;
            var dateFormat = _this.state.dateFormat;
            var error = ig_utils_1.resolveError(ig_utils_1.validateDate({ value: value, disableFuture: disableFuture, disablePast: disablePast, disableWeekends: disableWeekends, format: dateFormat }), t, i18nErrors);
            var range = value.split('-');
            var to;
            var from;
            if (!error) {
                if (range[0] && moment_timezone_1.default(range[0].trim(), dateFormat).isValid()) {
                    from = _this.moment(range[0].trim());
                }
                if (range[1] && moment_timezone_1.default(range[1].trim(), dateFormat, true).isValid()) {
                    to = _this.moment(range[1].trim());
                }
            }
            _this.handleUpdate({ action: 'setDay', payload: { to: to, from: from, text: value, error: error } });
        };
        return _this;
    }
    DateRange.getDerivedStateFromProps = function (props, state) {
        var rangeValue = props.rangeValue, displayFormat = props.displayFormat, lng = props.lng, timezone = props.timezone;
        var dateFormat = displayFormat || moment_timezone_1.default().locale(lng).localeData().longDateFormat('L');
        var prevRangeValue = state.rangeValue;
        var resetCondition = rangeValue &&
            state.rangeValue && // new and old ranges are truthy
            !rangeValue.to &&
            state.rangeValue.to && // new to is falsey, old to is truthy
            !rangeValue.from &&
            state.rangeValue.from; // new from is false, old from is truthy
        if (resetCondition) {
            return {
                to: undefined,
                from: undefined,
                formattedDate: '',
                rangeValue: { to: undefined, from: undefined },
            };
        }
        var updateFromFalseyRangeValueConditions = rangeValue && (!state.rangeValue || (state.rangeValue && !state.rangeValue.to && state.rangeValue && !state.rangeValue.from)); // new range value is truthy and old range value is falsey or old to and old from are falsey;
        if (updateFromFalseyRangeValueConditions) {
            if (rangeValue.to && rangeValue.from) {
                var to = ig_utils_1.configMoment(lng, timezone)(rangeValue.to);
                var from = ig_utils_1.configMoment(lng, timezone)(rangeValue.from);
                var formattedDate = from.format(dateFormat) + " - " + to.format(dateFormat);
                if (to.isValid() && from.isValid()) {
                    return { rangeValue: rangeValue, to: to, from: from, formattedDate: formattedDate };
                }
            }
        }
        var updateFromTruthyRangeValueConditions = rangeValue &&
            rangeValue.to &&
            rangeValue.from && // new rangeValue has truthy to and from
            prevRangeValue &&
            prevRangeValue.to &&
            prevRangeValue.from && // previous rangeValue has truthy to and from
            (prevRangeValue.to.toString() !== rangeValue.to.toString() || prevRangeValue.from.toString() !== rangeValue.from.toString()); // new to doesn't match old to, or new from doesn't match old from
        if (updateFromTruthyRangeValueConditions) {
            var to = ig_utils_1.configMoment(lng, timezone)(rangeValue.to);
            var from = ig_utils_1.configMoment(lng, timezone)(rangeValue.from);
            var formattedDate = from.format(dateFormat) + " - " + to.format(dateFormat);
            return { rangeValue: rangeValue, formattedDate: formattedDate, to: to, from: from };
        }
        return null;
    };
    DateRange.prototype.componentDidMount = function () {
        document.addEventListener('click', this.captureClick);
        var rangeValue = this.props.rangeValue;
        var dateFormat = this.genFormat().dateFormat;
        var datePlaceholder = this.genPlaceholder(dateFormat);
        var to = undefined;
        var from = undefined;
        var month = this.getMonth(this.moment());
        if (rangeValue && rangeValue.to) {
            to = this.moment(rangeValue.to);
        }
        if (rangeValue && rangeValue.from) {
            from = this.moment(rangeValue.from);
            month = this.getMonth(from);
        }
        this.setState(__assign({ to: to,
            from: from,
            month: month,
            dateFormat: dateFormat,
            datePlaceholder: datePlaceholder }, (rangeValue && { rangeValue: rangeValue })));
    };
    DateRange.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.captureClick);
    };
    DateRange.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, highlightWeekends = _a.highlightWeekends, showYearSelector = _a.showYearSelector, label = _a.label, disablePast = _a.disablePast, disableFuture = _a.disableFuture, disableWeekends = _a.disableWeekends, enabledBetween = _a.enabledBetween, disabled = _a.disabled, error = _a.error, lng = _a.lng, fluid = _a.fluid, closeOnSelection = _a.closeOnSelection, reserveSpace = _a.reserveSpace, helperText = _a.helperText, indicator = _a.indicator, viewType = _a.viewType, i18nShowToday = _a.i18nShowToday, i18nOk = _a.i18nOk, i18nCancel = _a.i18nCancel, i18nClear = _a.i18nClear;
        var _b = this.state, to = _b.to, from = _b.from, month = _b.month, formattedDate = _b.formattedDate, open = _b.open, openUp = _b.openUp, datePlaceholder = _b.datePlaceholder;
        month.locale(this.shimLocals(lng));
        return (React.createElement("div", { className: this.genClasses({ className: className, fluid: fluid, open: open, openUp: openUp, range: true, viewType: viewType }), ref: function (ref) { return (_this.menuRef = ref); } },
            React.createElement("div", { className: "overlay-position-wrap" },
                React.createElement("div", { className: "datetime-input-wrap" },
                    React.createElement(Input_1.default, { fluid: fluid, label: label, className: 'picker-input datetime-date', icon: "calendar", value: formattedDate, uncontrolled: true, placeholder: datePlaceholder, onChange: this.handleInputChange, onFocus: this.handleFocus.bind(this, { focused: true }), error: error, helperText: helperText, disabled: disabled, reserveSpace: reserveSpace, indicator: indicator })),
                this.state.open && (React.createElement("div", { className: "calendar-overlay " + (reserveSpace === false ? 'unreserved' : ''), ref: function (ref) { return (_this.overRef = ref); } },
                    React.createElement(Calendar_1.default, { month: month, to: to, from: from, range: viewType === 'standard', reducer: this.handleUpdate, showYears: showYearSelector, highlightWeekends: highlightWeekends, disablePast: disablePast, disableFuture: disableFuture, disableWeekends: disableWeekends, enabledBetween: enabledBetween, closeOnSelection: closeOnSelection, viewType: viewType, i18nShowToday: i18nShowToday, i18nOk: i18nOk, i18nCancel: i18nCancel, i18nClear: i18nClear }))))));
    };
    DateRange.defaultProps = {
        showYearSelector: false,
        closeOnDocumentClick: true,
        closeOnSelection: false,
        minuteStep: 30,
        viewType: 'standard',
    };
    return DateRange;
}(react_1.Component));
exports.DateRange = DateRange;
exports.default = localization_1.InjectLocalization(DateRange);
